import { Illustration, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export function VerifyInterviewAttendanceConfirmation() {
  return (
    <Stack
      spacing={8}
      sx={{
        display: "flex",
        alignItems: "center",
        textAlign: "center",
        py: 10,
      }}
    >
      <Illustration type="check" />

      <Text semibold variant="h5">
        Thank you for submitting your verification
      </Text>

      <Text sx={(theme) => ({ color: theme.palette.text.tertiary })}>
        A member of our team will reach out if we&apos;re unable to verify your attendance using the
        information provided.
      </Text>
    </Stack>
  );
}
